import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  
  // Use an emoji image with png extension
  const logo = "/images/emoji8.png";

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo-container">
          <Link to="/">
            <img src={logo} alt="Mojifi" className="logo" />
            <span className="logo-text">$MojiFi</span>
          </Link>
        </div>
        
        <div className="mobile-toggle" onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <nav className={`main-nav ${isNavOpen ? 'open' : ''}`}>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/instructions">How to Mojifi</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/telegram">X Community</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 